import React from 'react';
import Pill from '@99designs/frontend-components/components/Pill/Pill';
import { Ribbon } from '@99designs/frontend-components/components/Ribbon';
import Box from '../../Box';
import { DesignWithMetaCard } from '../../Card';
import DesignCard from '../../DesignCard';
import Heading from '../../Heading';
import Link, { HeadingLink } from '../../Link';
import Paragraph from '../../Paragraph';
import StatsColumns from '../../StatsColumns';
import { Stat } from '../../StatsColumns';
import TruncateText from '../../TruncateText';
import VerticalSpacing from '../../VerticalSpacing';

interface Design {
    url: string;
    alt: string;
}

export interface Props {
    completedAt: React.ReactNode;
    contestPath: string;
    title: string;
    description: string | null;
    categoryKey: string;
    packageTitle: string;
    design: Design;
    stats: Stat[];
}

function CompletedContestCard({
    completedAt,
    contestPath,
    title,
    description,
    categoryKey,
    packageTitle,
    design,
    stats,
}: Props) {
    return (
        <DesignWithMetaCard
            variations={['completed-contest']}
            meta={
                <>
                    <Box>
                        <Pill variations={['tag']}>{__('Finished')}</Pill>
                        <Box type="span" paddingLeft="space5">
                            {completedAt}
                        </Box>
                    </Box>
                    <VerticalSpacing verticalSpacing={'space5'} />
                    <Heading type="h3" variations={['h5', 'no-margin']}>
                        <HeadingLink href={contestPath}>
                            <TruncateText text={title} maxHeight={60} />
                        </HeadingLink>
                    </Heading>
                    <VerticalSpacing verticalSpacing={'space6'} />
                    <Box>
                        <Link href={`/pricing/${categoryKey}`}>{packageTitle}</Link>
                    </Box>

                    <VerticalSpacing verticalSpacing={'space6'} />
                    <Paragraph variations={['soft', 'small', 'no-margin']}>
                        {description ? <TruncateText text={description} maxHeight={80} /> : null}
                    </Paragraph>
                    <Box paddingTop="space7">
                        <StatsColumns stats={stats} />
                    </Box>
                </>
            }
            image={
                <Link
                    href={contestPath}
                    style={{
                        height: '320px',
                        width: '320px',
                    }}
                >
                    <DesignCard
                        src={design.url}
                        alt={design.alt}
                        ribbon={<Ribbon variations={['medium']}>{__('Winner')}</Ribbon>}
                        variations={['lazyload']}
                        width={320}
                        height={320}
                    />
                </Link>
            }
        />
    );
}

export default CompletedContestCard;
